import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import httpClient from "../../custom-hooks/httpClient";
import Modal from "../Modal";

function NinUpdate({ onClose }) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nin, setNin] = useState({
    nin: "",
    confirm_nin: "",
  });

  const handleChange = (e) => {
    setNin({ ...nin, [e.target.id]: e.target.value });
  };

  const userToken = localStorage.getItem("tk");

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const id = localStorage.getItem("id");

    if (nin.nin !== nin.confirm_nin) {
      toast.error("NIN mismatch!");
      return;
    }

    httpClient
      .put(`/users/${id}`, {
        nin: nin.nin,
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then(({ status }) => {
        setIsSubmitting(false);
        if (status === 200) {
          toast.success(
            "Your NIN has been submitted for verification and will be processed shortly."
          );
        }
      })
      .catch((err) => {
        setIsSubmitting(false);
        toast.error(err.response.data.message);
      });
    onClose();
  };

  useEffect(() => {
    const isNinValid = nin.nin.length === 11 && nin.confirm_nin.length === 11;
    const areFieldsValid =
      Object.values(nin).every((value) => value !== "") && isNinValid;
    setAreFieldsSet(areFieldsValid);
  }, [nin]);

  return (
    <>
      <section>
        <Modal
          showModal={true}
          setShowModal={onClose}
          title="NIN Update"
          showCloseButton={true}
          clickOut={true}
        >
          <p className="fs-sm text-center text-muted mb-6 mb-md-6">
            For continued service, update your account with your NIN.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 col-12 mb-3">
                <input
                  type="password"
                  name="nin"
                  id="nin"
                  className="form-control text-primary"
                  placeholder="Enter NIN"
                  title="Numbers only (e.g. 12345678912)"
                  maxLength="11"
                  pattern="[0-9]{11}"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 col-12">
                <input
                  type="password"
                  name="confirm_nin"
                  id="confirm_nin"
                  className="form-control text-primary"
                  placeholder="Confirm NIN"
                  title="Numbers only (e.g. 12345678912)"
                  maxLength="11"
                  pattern="[0-9]{11}"
                  required
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-12">
                {areFieldsSet ? (
                  isSubmitting ? (
                    <button className="btn w-100 btn-primary mt-3 lift">
                      <Loader type="Oval" color="#fff" width={20} height={20} />
                    </button>
                  ) : (
                    <button
                      className="btn w-100 btn-primary mt-3 lift"
                      type="submit"
                    >
                      Submit
                    </button>
                  )
                ) : (
                  <button
                    className="btn w-100 btn-primary mt-3 lift"
                    type="button"
                    disabled
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </form>
        </Modal>
      </section>
    </>
  );
}

export default NinUpdate;
